angular.module('picmonicng').directive('relatedModal', [
  function () {
    return {
      restrict: 'A',
      scope: {
        fact: '=',
        cardId: '=',
      },
      controller: [
        '$scope',
        '$modal',
        '$rootScope',
        'LearnService',
        function ($scope, $modal, $rootScope, LearnService) {
          $scope.openModal = function () {
            var scope = $rootScope.$new();
            scope.fact = $scope.fact;
            scope.cardId = $scope.cardId;

            $scope.modal = $modal.open({
              templateUrl: '/templates/modals/related-picmonics.html',
              windowClass: 'below-nav learn-light-modal related-picmonics-modal',
              backdropClass: 'below-nav',
              scope: scope,
              size: 'xl',
              controller: [
                '$scope',
                '$filter',
                '$modalInstance',
                'Picmonics',
                function ($scope, $filter, $modalInstance, Picmonics) {
                  LearnService.relatedModalInstance = $modalInstance;
                  $scope.loading = true;
                  $scope.related = Picmonics.query({
                    card_id: $scope.cardId,
                    type: 'by_fact',
                    fact_id: $scope.fact.fact_id,
                  });

                  $scope.related.$promise.then(
                    function () {
                      if (!$scope.related.length) {
                        angular.element('.related-picmonics-modal').removeClass('related-picmonics-modal');
                      }

                      $scope.loading = false;
                    },
                    function () {
                      $scope.loading = false;
                    }
                  );

                  $scope.close = function () {
                    $modalInstance.close();
                  };
                },
              ],
            });
          };
        },
      ],
      link: function (scope, element, attrs) {
        element.on('click', function () {
          send_ga('event', 'Learn', 'Ditto Clicked');
          scope.$apply(function () {
            scope.openModal();
          });
        });
      },
    };
  },
]);
